import { makeErrorWithCode } from '@neo-one/utils';
export var StackItemType;
(function (StackItemType) {
    StackItemType[StackItemType["ByteArray"] = 0] = "ByteArray";
    StackItemType[StackItemType["Boolean"] = 1] = "Boolean";
    StackItemType[StackItemType["Integer"] = 2] = "Integer";
    StackItemType[StackItemType["InteropInterface"] = 64] = "InteropInterface";
    StackItemType[StackItemType["Array"] = 128] = "Array";
    StackItemType[StackItemType["Struct"] = 129] = "Struct";
    StackItemType[StackItemType["Map"] = 130] = "Map";
})(StackItemType || (StackItemType = {}));
export const InvalidStackItemTypeError = makeErrorWithCode('INVALID_STACK_ITEM_TYPE', (stackItemType) => `Expected StackItemType, found: ${stackItemType.toString(16)}`);
const isStackItemType = (value) => StackItemType[value] !== undefined;
export const assertStackItemType = (value) => {
    if (isStackItemType(value)) {
        return value;
    }
    throw new InvalidStackItemTypeError(value);
};

//# sourceMappingURL=StackItemType.js.map
